import type { Point2d, Rectangle2d } from ".."
import { rotatePoint } from ".."

export const boxToPoints = (box: Rectangle2d): Point2d[] => {
  const { x, y, w, h, r } = box
  const points = [
    { x, y },
    { x, y: y + h },
    { x: x + w, y: y + h },
    { x: x + w, y },
  ]
  if (r === 0) {
    return points
  }
  const rotatedPoints = points.map((point) => rotatePoint({ x, y }, point, r))

  return rotatedPoints
}
